import styled from 'styled-components';

const Form = styled.form`
    margin: 0 auto;
    max-width: 346px;
`;

export default Form;
